module.exports = __webpack_public_path__ + "1708654020752/assets/img/logo.ac71f656.png";